import { defineMessages } from 'react-intl';

export const filtersModalMessages = defineMessages({
  sortBy: {
    id: `filterModal.sortBy`,
    defaultMessage: 'Sort by:',
  },
  collection: {
    id: `filterModal.collection`,
    defaultMessage: 'Collection',
  },
  type: {
    id: `filterModal.type`,
    defaultMessage: 'Type',
  },
  diameter: {
    id: `filterModal.diameter`,
    defaultMessage: 'Diameter (mm)',
  },
  caseMaterial: {
    id: `filterModal.caseMaterial`,
    defaultMessage: 'Case material',
  },
  dialColor: {
    id: `filterModal.dialColor`,
    defaultMessage: 'Dial color',
  },
  price: {
    id: `filterModal.price`,
    defaultMessage: 'Price',
  },
  lug: {
    id: `filterModal.lug`,
    defaultMessage: 'Lug',
  },
  lugType: {
    id: `plp.keyFeatures.lugType`,
    defaultMessage: 'Lug type',
  },
  material: {
    id: `filterModal.material`,
    defaultMessage: 'Material',
  },
  color: {
    id: `filterModal.color`,
    defaultMessage: 'Color',
  },
  strapLength: {
    id: `filterModal.strapLength`,
    defaultMessage: 'Strap length',
  },
  buckle: {
    id: `filterModal.buckle`,
    defaultMessage: 'Buckle',
  },
  storeType: {
    id: `filterModal.storeType`,
    defaultMessage: 'Store Type',
  },
  reference: {
    id: `filterModal.reference`,
    defaultMessage: 'Reference',
  },
  lensColor: {
    id: `pdp.technicalData.lens.color`,
    defaultMessage: 'Lens color',
  },
  frameMaterial: {
    id: `pdp.technicalData.frame.material`,
    defaultMessage: 'Frame material',
  },
  frameColor: {
    id: `filterModal.frameColor`,
    defaultMessage: 'Frame color',
  },
  priceFrom: {
    id: `filterModal.priceFrom`,
    defaultMessage: 'From',
  },
  priceTo: {
    id: `filterModal.priceTo`,
    defaultMessage: 'To',
  },
});
